var OCS = OCS || {};
OCS.BootFunctions = OCS.BootFunctions || {};
OCS.BootFunctions.application = OCS.BootFunctions.application || {};
OCS.WxBriefing = OCS.WxBriefing || {};
OCS.Settings = OCS.Settings || {};
OCS.WxBriefing.Classes = OCS.WxBriefing.Classes || {};
OCS.WxBriefing.Classes.UIMobileMenu = new Class({
    Extends: OCS.WxBriefing.Classes.UIMenu,
    options: {
        animation_duration: 200,
    },
    menu_slide: null,
    menu_slide_wrapper: null,
    initialize: function (options) {
        if (OCS.WxBriefing.Live[this.manager_name]) {
            return OCS.WxBriefing.Live[this.manager_name];
        }
        this.parent();
        var nav = $$("#header nav")[0];
        var nav_parent = nav.getParent();
        this.menu_slide_wrapper = new Element('div', {class: "menu_slide_wrapper"});
        this.menu_slide_wrapper.inject(nav_parent);
        nav.inject(this.menu_slide_wrapper);
        this.menu_slide = new Fx.Slide(nav, {mode: 'horizontal', wrapper: this.menu_slide_wrapper, hideOverflow: false});
        this.menu_slide.hide();
        $$("i.sprite-mobile-menu-button").addEvent('click', this.toggle_mobile_nav_menu.bind(this));
        this.setup_mobile_nav();

        var mp = this.get_myproducts_menu();
        mp.addEvent('myproducts_ready', this.on_myproducts_ready.bind(this));
    },
    build_menu: function (data) {
        this.element.getElements('div.panel_config').removeEvents();
        this.element.getElements('div.product_content').removeEvents();
        this.parent(data);
        this.element.getElements('div.panel_config').addEvent('click', this.on_panel_config_click.bind(this));
        this.element.getElements('div.product_content').addEvent('click', this.on_product_click.bind(this));
    },
    on_myproducts_ready: function (mp) {
        var el = mp.ul_element;
        el.getElements('div.panel_config').addEvent('click', this.on_panel_config_click.bind(this));
        el.getElements('div.product_content').addEvent('click', this.on_product_click.bind(this));
    },
    on_panel_config_click: function (event) {
        event.stop();
        this.reset_menu();
        OCS.WxBriefing.Functions.get_url_manager().update_url_state(event.target.get('data-href'), 0);
    },
    on_product_click: function (event) {
        event.stop();
        this.load_mobile_product(event.target.get('data-entry_id'));
    },

    setup_mobile_nav: function () {
        if (navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPad/i)) {
            var viewportmeta = document.querySelectorAll('meta[name="viewport"]')[0];
            if (viewportmeta) {
                viewportmeta.content = 'width=device-width, minimum-scale=1.0, maximum-scale=1.0';
                document.body.addEventListener('gesturestart', function () {
                    viewportmeta.content = 'width=device-width, minimum-scale=0.25, maximum-scale=1.6';
                }, false);
            }
        }
    },
    toggle_mobile_nav_menu: function (e) {
        this.reset_menu({mobile_nav_open: true, keep_myproducts: true, keep_submenu: true})
        this.menu_slide.toggle();
    },
    load_mobile_product: function (entry_id) {
        if (!OCS.Utilities.is_null(entry_id)) {
            var cp = document.id("mobile_panel_chooser").retrieve('panel_chooser').current_panel;
            var state = {};
            state['p' + cp] = {};
            state['p' + cp].entry_id = entry_id;
            OCS.WxBriefing.Functions.get_url_manager().update_url_state(state, 0);
            OCS.WxBriefing.Functions.get_ui_menu().reset_menu();
        }
    },
    reset_menu: function (event_data) {
        this.parent(event_data);
        if (event_data === undefined || event_data.mobile_nav_open === undefined || !event_data.mobile_nav_open) {
            this.menu_slide.hide();
        }

    }
}); // End OCS.WxBriefing.Classes.UIMobileMenu


